import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'
import {
  type IParamsGetSurveys,
  type IParamsCreateSurvey,
  type IResponseCreateSurvey,
  type IResponseGetSurveys,
  type IResponseGetSurvey,
  type IResponseFullSurvey,
} from './types'

class Api {
  createSurvey(params: IParamsCreateSurvey): Promise<AxiosResponse<IResponseCreateSurvey>> {
    return baseApi.post('survey/api/surveys', params)
  }

  getSurveys(params?: IParamsGetSurveys): Promise<AxiosResponse<IResponseGetSurveys>> {
    return baseApi.get('survey/api/surveys', { params })
  }

  deleteSurvey(id: number): Promise<AxiosResponse<void>> {
    return baseApi.delete(`survey/api/surveys/${id}`)
  }

  activateSurvey(
    id: number,
    params: { is_active: boolean }
  ): Promise<AxiosResponse<IResponseGetSurvey>> {
    return baseApi.put(`survey/api/surveys/${id}/status`, params)
  }

  getSurvey(id: number): Promise<AxiosResponse<IResponseFullSurvey>> {
    return baseApi.get(`survey/api/surveys/${id}`)
  }

  updateSurvey(
    id: number,
    params: IParamsCreateSurvey
  ): Promise<AxiosResponse<IResponseCreateSurvey>> {
    return baseApi.put(`survey/api/surveys/${id}`, params)
  }
}

export const SurveysApi = new Api()
